import { useEffect, useRef } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';
import { useTripPositionsAnalysisStore } from '../../stores/analysis/useTripPositionsAnalysisStore';

export function useTripPositionsAnalysisSocket() {

    const socket = useSocketStore(
        state => state.socket
    );

    const countRef = useRef(0);

    useEffect(() => {

        if (!socket) {
            return;
        }

        const { setPosition } =
            useTripPositionsAnalysisStore.getState();

        const handlePosition = (data) => {

            countRef.current++;

            console.log(
                'positions',
                countRef.current
            );

            setPosition(data);

        };

        socket.on(
            'trip:positions:analysis',
            handlePosition
        );

        return () => {

            socket.off(
                'trip:positions:analysis',
                handlePosition
            );

        };

    }, [socket]);

}